<form [formGroup]="searchForm">
  <app-card>
      <div class="flex gap-4">
        <div class="w-1/3">
          <app-input-group>
            <label appLabel>{{ 'connectionpoint.identification' | translate }}</label>
            <input type="search" formControlName="connectionPointIdentification" appInput [placeholder]="'connectionpoint.identification' | translate">
          </app-input-group>
        </div>

        <div class="w-1/3">
          <app-input-group>
            <label appLabel>{{ 'meter.meterNumber' | translate }}</label>
            <input type="search" formControlName="meterNumber" appInput [placeholder]="'meter.meterNumber' | translate">
          </app-input-group>
        </div>

        <div class="w-1/3">
          <app-input-group>
            <label appLabel>{{ 'meter.alternativeMeterNumber' | translate }}</label>
            <input type="search" formControlName="alternativeMeterNumber" appInput [placeholder]="'meter.alternativeMeterNumber' | translate">
          </app-input-group>
        </div>
      </div>

      <div class="flex gap-4">
        <div class="w-1/3">
          <app-input-group>
            <label appLabel>{{ 'address.streetName' | translate }}</label>
            <input type="search" formControlName="streetName" appInput [placeholder]="'address.streetName' | translate">
          </app-input-group>
        </div>

        <div class="w-1/3">
          <app-input-group>
            <label appLabel>{{ 'address.streetNumber' | translate }}</label>
            <input type="search" formControlName="streetNumber" appInput [placeholder]="'address.streetNumber' | translate">
          </app-input-group>
        </div>

        <div class="w-1/3">
          <app-input-group>
            <label appLabel>{{ 'address.zipCode' | translate }}</label>
            <input type="search" formControlName="postalCode" appInput [placeholder]="'address.zipCode' | translate">
          </app-input-group>
        </div>
      </div>

      <div>
        <button
          appButton
         (click)="search()">
          {{ 'common.search' | translate }}
        </button>
      </div>
  </app-card>
</form>

<app-table
  #table
  [config]="connectionPointTable"
  [(selectedElements)]="selectedElements"
></app-table>
